export const Facebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="32"
    viewBox="0 0 24 32"
    fill="none"
  >
    <path
      d="M22.5 4C23.33 4 24 4.67 24 5.5V26.5C24 27.33 23.33 28 22.5 28H16.5V19H19.5L20.25 15.25H16.5V13.75C16.5 12.25 17.25 11.5 18.75 11.5H20.25V7.75H17.25C14.49 7.75 12.75 9.91 12.75 13V15.25H9.75V19H12.75V28H1.5C1.10218 28 0.720644 27.842 0.43934 27.5607C0.158035 27.2794 0 26.8978 0 26.5L0 5.5C0 4.67 0.67 4 1.5 4H22.5Z"
      fill="#090F3F"
    />
  </svg>
)

export const Instagram = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="32"
    viewBox="0 0 24 32"
    fill="none"
  >
    <path
      d="M16.9797 4.0002C17.9165 3.96786 18.8502 4.12674 19.7236 4.46716C20.597 4.80759 21.3918 5.3224 22.0597 5.9802C22.7035 6.64801 23.2068 7.43809 23.5401 8.30376C23.8733 9.16942 24.0296 10.0931 23.9997 11.0202V20.9802C23.9997 23.0602 23.3197 24.8502 22.0197 26.1102C20.6406 27.3834 18.8156 28.0624 16.9397 28.0002H7.0597C5.19946 28.0578 3.39171 27.3786 2.0297 26.1102C1.35455 25.434 0.82588 24.6259 0.47663 23.7365C0.127381 22.847 -0.0349675 21.8952 -0.000301 20.9402V11.0202C-0.000301 6.8002 2.7997 4.0002 7.0197 4.0002H16.9797ZM17.0297 6.2302H7.0597C5.6097 6.2302 4.3597 6.6602 3.5297 7.4802C3.08619 7.95259 2.74249 8.50955 2.51912 9.11779C2.29576 9.72603 2.19732 10.3731 2.2297 11.0202V20.9402C2.2297 22.4402 2.6597 23.6402 3.5297 24.5202C4.50002 25.3784 5.76553 25.8265 7.0597 25.7702H16.9397C18.2339 25.8265 19.4994 25.3784 20.4697 24.5202C20.9355 24.0593 21.3005 23.5067 21.5415 22.8973C21.7825 22.2879 21.8943 21.6351 21.8697 20.9802V11.0202C21.902 9.73287 21.4363 8.48273 20.5697 7.5302C20.0973 7.0867 19.5404 6.74299 18.9321 6.51962C18.3239 6.29626 17.6768 6.19782 17.0297 6.2302ZM11.9997 9.7602C15.3897 9.7602 18.1997 12.5602 18.1997 15.9602C18.1997 17.6045 17.5465 19.1815 16.3838 20.3443C15.221 21.507 13.644 22.1602 11.9997 22.1602C10.3554 22.1602 8.77836 21.507 7.61564 20.3443C6.45291 19.1815 5.7997 17.6045 5.7997 15.9602C5.7997 14.3159 6.45291 12.7389 7.61564 11.5761C8.77836 10.4134 10.3554 9.7602 11.9997 9.7602ZM11.9997 11.9802C10.9484 11.9855 9.94168 12.4054 9.19829 13.1488C8.45491 13.8922 8.03496 14.8989 8.0297 15.9502C8.03496 17.0015 8.45491 18.0082 9.19829 18.7516C9.94168 19.495 10.9484 19.9149 11.9997 19.9202C13.051 19.9149 14.0577 19.495 14.8011 18.7516C15.5445 18.0082 15.9644 17.0015 15.9697 15.9502C15.9644 14.8989 15.5445 13.8922 14.8011 13.1488C14.0577 12.4054 13.051 11.9855 11.9997 11.9802ZM18.4397 8.2102C18.811 8.2102 19.1671 8.3577 19.4296 8.62025C19.6922 8.8828 19.8397 9.2389 19.8397 9.6102C19.8397 9.98151 19.6922 10.3376 19.4296 10.6002C19.1671 10.8627 18.811 11.0102 18.4397 11.0102C18.0684 11.0102 17.7123 10.8627 17.4497 10.6002C17.1872 10.3376 17.0397 9.98151 17.0397 9.6102C17.0397 9.2389 17.1872 8.8828 17.4497 8.62025C17.7123 8.3577 18.0684 8.2102 18.4397 8.2102Z"
      fill="#090F3F"
    />
  </svg>
)

export const LinkedIn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="32"
    viewBox="0 0 24 32"
    fill="none"
  >
    <path
      d="M22.23 4H1.77C0.8 4 0 4.77 0 5.72V26.28C0 27.23 0.8 28 1.77 28H22.23C23.21 28 24 27.23 24 26.28V5.72C24 4.77 23.2 4 22.23 4ZM7.27 24.1H3.65V13.24H7.27V24.1ZM5.47 11.76H5.44C4.22 11.76 3.44 10.93 3.44 9.89C3.44 8.83 4.24 8.02 5.49 8.02C6.73 8.02 7.49 8.82 7.51 9.89C7.51 10.93 6.73 11.76 5.46 11.76H5.47ZM20.34 24.1H16.71V18.3C16.71 16.85 16.19 15.85 14.88 15.85C13.88 15.85 13.28 16.52 13.01 17.17C12.91 17.4 12.9 17.72 12.9 18.05V24.1H9.28C9.28 24.1 9.33 14.28 9.28 13.26H12.91V14.8C13.2377 14.2313 13.7146 13.763 14.2892 13.4457C14.8638 13.1285 15.5141 12.9743 16.17 13C18.56 13 20.35 14.56 20.35 17.89V24.1H20.34Z"
      fill="#090F3F"
    />
  </svg>
)

export const TikTok = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="32"
    viewBox="0 0 24 32"
    fill="none"
  >
    <path
      d="M18.5 4H14V17.5C14 19.99 11.99 22 9.5 22C7.01 22 5 19.99 5 17.5C5 15.01 7.01 13 9.5 13C10.3 13 11.06 13.22 11.7 13.6V8H18.5V4Z"
      fill="#090F3F"
    />
  </svg>
)
